import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

export class ModContact extends ModuleComponent{
    ready(){
        super.ready();
        this.$contactForm = this.findMember("contact-form");
        this.$contactForm.submit(
            (ev)=>{
                ev.preventDefault();
                let $button = this.findMember("send-form");
                this.$contactForm.checkRestrictions().then(
                    (isOk)=>{
                        if(isOk){
                            if(this.$root.find("textarea[name='comments']").val().length==0){
                                UtilsService.alertEndpointResponse("El campo consulta no tiene datos");
                                return;
                            }
                            $button.prop("disabled",true);
                            GvfService.endpoint("/web/contact/send-contact-form",
                                {form: this.$contactForm.getValues()}).then(
                                (resp)=>{
                                    UtilsService.alertEndpointResponse(resp, ()=>{
                                        window.location.reload();
                                    });
                                }
                            ).catch(
                                (resp)=>{
                                    UtilsService.alertEndpointResponse(resp);
                                }).finally(
                                ()=>{
                                    $button.prop("disabled",false);
                                }
                            );
                        }
                    }
                );
            }
        );

        this.findMember("send-form").click(
            ()=>{
                this.$contactForm.submit();
            }
        );

    }
}

